<template>
  <div class="manageInfo">
    <!-- 其他信息 -->
    <div class="wrapper-box">
      <listItem :label="'固定电话1'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
                :textAlign="'right'">{{details.linePhone1 || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'固定电话2'"
                :labelWidth="114"
                :textAlign="'right'"
                :ctnColor="'#333333'"
                :showRight="false">{{details.linePhone2 || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'传真号码'"
                :labelWidth="114"
                :textAlign="'right'"
                :ctnColor="'#333333'"
                :showRight="false">{{details.fex || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'邮政编码'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
                :textAlign="'right'">{{details.postCode || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'公司邮箱'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
                :textAlign="'right'">{{details.email || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'公司网址'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
                :textAlign="'right'">{{details.webSite || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'社会保险登记证号'"
                :labelWidth="154"
                :ctnColor="'#333333'"
                :showRight="false"
                :textAlign="'right'">{{details.socialInsuranceNum || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'旅行社责任险保险公司'"
                :labelWidth="154"
                :ctnColor="'#333333'"
                :showRight="false"
                :textAlign="'right'">{{details.liabilityInsuranceCompany || '暂无信息'}}</listItem>
    </div>
  </div>
</template>
<script>
    import listItem from './components/list-itemone';
    import rline from './components/line';
    export default {
        components: {
            rline,
            listItem
        },

        data () {
            return {
                details: {}
            };
        },

        computed: {},

        watch: {},

        methods: {
        },

        mounted () {
            if ((JSON.parse(localStorage.travelDetail)).travelAgencyDetails) {
                this.details = (JSON.parse(localStorage.travelDetail)).travelAgencyDetails
            }
        },
        created () { }
    };
</script>
<style scoped lang="less">
.manageInfo {
  width: 100%;
  height: 100%;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding-top: 16px;
  .wrapper-box {
    width: 351px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin: 0 12px;
  }
}
</style>
